import React from 'react'

const Settings = () => {
  return (
    <div className='row-start-2 bg-drk00  text-gray-600 text-xl font-poppins flecx justify-center items-center '>
      Settings section
        {/* <div></div> */}
    </div>
  )
}

export default Settings